import axios from 'config/axios';
import { CoverageFileType } from '../feeds.types';

const getFeedCoverageFile = async (
  fileName: string,
  purposeId: string,
  coverageFileType: CoverageFileType
) =>
  await axios
    .get(`GetCoverageFile?fileName=${fileName}&purposeId=${purposeId}`, {
      responseType: 'arraybuffer',
      headers: { 'Content-Type': 'blob' },
    })
    .then((response) => {
      const outputFilename = `feed-${purposeId}-${coverageFileType}-coverage.zip`;
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);

      link.click();
    });

export default getFeedCoverageFile;
